import React, {useState} from 'react';
import {Button, Checkbox, Col, Collapse, Divider, Form, Input, InputNumber, message, Modal, Row, Upload} from 'antd';
import {LoadingOutlined, UploadOutlined} from '@ant-design/icons';
import {CONSTANTS} from "../utils/constant";
import {API} from "../api/api";
import {useNavigate} from "react-router-dom";
import Results from './results.js'
import {Exception} from "sass";
import cocomaps1logo from "../assets/cocomaps1_logo.png";

const {Panel} = Collapse;


export default function InputForm() {

    const navigate = useNavigate();
    const [pdbForm] = Form.useForm();
    const [form] = Form.useForm();

    const [fileList, setFileList] = useState(null);

    const [pdbInfo, setPdbInfo] = useState(null);

    const [chains, setChains] = useState([]);
    const [selectedChain, setSelectedChain] = useState({'ranges_set_1': [], 'ranges_set_2': []});

    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const [dataFolder, setDataFolder] = useState(null);
    const [pdbCode, setPdbCode] = useState(null);

    const [pn, setPn] = useState("");
    const [mol1, setMol1] = useState("");
    const [mol2, setMol2] = useState("");

    const [availableChainsA, setAvailableChainsA] = useState([]);
    const [availableChainsB, setAvailableChainsB] = useState([]);

    const onFinish = async (values) => {

        try {
            let pdbInfo;

            setLoading(true);
            form.resetFields();

            if (values.pdbCode) {
                pdbInfo = await API.get(CONSTANTS.PHP_SCRIPT_BASE_PATH + "get_info.php?pdbCode=" + values.pdbCode);
            } else {
                pdbInfo = await API.submit({pdbFile: fileList}, CONSTANTS.PHP_SCRIPT_BASE_PATH + "get_info.php");
            }

            if (pdbInfo.data == "false") {
                throw new Exception("invalid code");
            }

            pdbInfo.data = JSON.parse(pdbInfo.data);
            console.log(pdbInfo);

            setPdbInfo(pdbInfo);
            let chains = Array.from((Object.keys(pdbInfo.data)).map(c => {
                return {'label': c, 'value': c}
            }));
            setChains(chains);
            setAvailableChainsA(chains);
            setAvailableChainsB(chains);

        } catch (error) {
            reset_all();
            message.error('Insert a valid PDB Code or upload a valid PDB file');
        } finally {
            setLoading(false);
        }
    }

    const reset_all = () => {
        setLoading(false);
        setChains([]);
        setPdbInfo(null);
        setSelectedChain({'ranges_set_1': [], 'ranges_set_2': []});
        form.resetFields();
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const props = {
        name: 'file',
        multiple: false,
        beforeUpload: () => false,
        onChange(info) {
            setFileList(info);
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    const readFileContent = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                resolve(event.target.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };

            reader.onprogress = (e) => {
                if (e.lengthComputable) {
                    const percentLoaded = (e.loaded / e.total) * 100;
                    console.log(percentLoaded);
                }
            }

            reader.readAsText(file);
        });
    };

    const onChainSelected = (chain) => {
        return (checkedValues) => {
            const mappedCheckedValues = checkedValues.map((chain) => {
                const rangeStart = pdbInfo.data[chain].rangeStart;
                const rangeEnd = pdbInfo.data[chain].rangeEnd;
                return {chain: chain, start: rangeStart, end: rangeEnd}
            });

            const newSelectedChainValues = {...selectedChain, [chain]: mappedCheckedValues};
            setSelectedChain(newSelectedChainValues);
            form.setFieldsValue({[chain]: mappedCheckedValues});
            if (chain === 'ranges_set_1' && checkedValues.length === 0) {
                form.setFieldsValue({'ranges_set_2': [], 'chainMol2': []});
            }

            const availableChains = chains.filter(c => !checkedValues.includes(c.value));
            if (chain === 'ranges_set_1') {
                setAvailableChainsB(availableChains);
            } else {
                setAvailableChainsA(availableChains);
            }
        }
    }

    const formInitialValues = {
        CUT_OFF: 5.0,
        HBOND_DIST: 3.9,
        HBOND_ANGLE: 90,
        SBRIDGE_DIST: 4.5,
        WBRIDGE_DIST: 3.9,
        CH_ON_DIST: 3.6,
        HALOGEN_THETA1: 165,
        HALOGEN_THETA2: 120,
        METAL_DIST: 3.2,
        PI_PI_DIST: 5.5,
        PI_PI_THETA: 80,
        PI_PI_GAMMA: 90,
        CATION_PI_DIST: 5.0,
        ANION_PI_DIST: 5.0,
        LONEPAIR_PI_DIST: 5.0,
        AMINO_PI_DIST: 5.0,
        CH_ON_ANGLE: 110,
        C_H_PI_DIST: 4.5,
        C_H_PI_THETA1: 120,
        C_H_PI_THETA2: 30,
        NSOH_PI_DIST: 4.5,
        NSOH_PI_THETA1: 120,
        NSOH_PI_THETA2: 30,
        APOLAR_DIST: 0.5,
        POLAR_DIST: 0.5
    };

    const check_if_finished = async (folder) => {
        return new Promise((res, rej) => {
            let id = setInterval(async () => {
                let response = await API.submit({data_folder: folder}, CONSTANTS.PHP_SCRIPT_BASE_PATH + "check_run_completed.php");
                if (response.res) {
                    clearInterval(id);
                    res();
                }
            }, 5000);
        })
    }

    const valuesFormOnFinish = (values) => {
        setModalVisible(true);
        const pdbCode = pdbForm.getFieldValue('pdbCode') ? pdbForm.getFieldValue('pdbCode')
            : fileList.file.name.split('.').slice(0, -1).join('.');
        //setPdbCode(pdbCode);

        if (!values.chains_set_1 || values.chains_set_1.length === 0) {
            const all_chains = chains.map(chain => chain.value);
            const all_ranges = Object.keys(pdbInfo.data).map(k => {
                return {chain: k, start: pdbInfo.data[k].rangeStart, end: pdbInfo.data[k].rangeEnd};
            });
            values.chains_set_1 = all_chains;
            values.chains_set_2 = all_chains;
            values.ranges_set_1 = all_ranges;
            values.ranges_set_2 = all_ranges;
            setSelectedChain({ranges_set_1: all_ranges, ranges_set_2: all_ranges});
        }

        API.submit({
            ...values,
            'pdbCode': pdbForm.getFieldValue('pdbCode'),
            'pdbFile': fileList
        }, CONSTANTS.PHP_SCRIPT_BASE_PATH + "run_cocomaps.php").then(async (response) => {
            form.resetFields();
            await check_if_finished(response.data_folder);
            setPdbCode(response.pdb_code);
            setDataFolder(response.data_folder);
            setPn(values.PROJECT_NAME != null ? values.PROJECT_NAME : "");
            setMol1(values.MOL_NAME_1 != null ? values.MOL_NAME_1 : "");
            setMol2(values.MOL_NAME_2 != null ? values.MOL_NAME_2 : "");
        });
    };

    const resetForm = () => {
        pdbForm.resetFields();
        form.resetFields();
        setChains([]);
        setPdbInfo(null);
        setSelectedChain({'ranges_set_1': [], 'ranges_set_2': []});
    }

    return (
        <>
            <div style={{padding: '30px'}}>
                <h1>Welcome to COCOMAPS 2.0</h1>
                <p>
                    COCOMAPS (bioCOmplexes COntact MAPS) 2.0 is a web server to easily and effectively identify, analyze
                    and visualize interactions at the interface of biocomplexes consisting of protein, RNA and/or DNA
                    molecules.
                </p>
                <p>
                    Users only need to: i) download input files directly from the wwPDB or upload their own mmCIF/PDB
                    formatted files, and ii) select the chain identifiers for the molecules involved in the interaction
                    to be analysed.
                </p>
                <p>
                    COCOMAPS 2.0 output includes interactive tables with a characterization of the interface in 16
                    specific types of atomic interactions; an interactive Mol* visualization, which encompasses all the
                    atomic interactions at
                    the interface; multiple summary representations of the interface, as a pie chart, a heatmap, a 2D
                    and a 3D atomic contact map; a characterization of the interface area and residues at the interface,
                    based on the buried
                    surface upon complex formation.
                </p>
                <p>
                    COCOMAPS 2.0 is freely accessible to all users, including commercial ones, under an open-access
                    license. It can straightforwardly be applied to the analysis, visualization and comparison of both
                    experimental and
                    predicted 3D structures of biological complexes.
                </p>
                <p>
                    <span style={{ color: "#3b73b9", fontWeight: "bold" }}>Citing COCOMAPS 2.0</span><br/>
                    <p style={{ fontFamily: "Arial, sans-serif", fontSize: "14px", fontWeight:"bold", color: "#000", lineHeight: "1.4", margin: 0 }}>
                        COCOMAPS 2.0: a web server for identifying, analyzing, and visualizing atomic interactions at the
                        interface of biomolecular complexes
                        Chawla, M.; Kalra, U.; Petta, A.; Sharma, S.; Shaikh, A. R.; Cavallo, L.; Oliva, R. Bioinformatics
                        2025, 41, btaf606. (<a
                        href='https://academic.oup.com/bioinformatics/article/41/12/btaf606/8363873'>link</a>)
                    </p>
                </p>
                <p>
                    <a href='https://aocdweb.com/BioTools/cocomaps2/cocomaps2_video_tutorial.mp4'>Here a video tutorial
                        for cocomaps 2.0</a>
                </p>
            </div>

            <div style={{paddingLeft: '30px'}}>
                <p style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    You may find
                    <a target="_blank" rel="noreferrer" href="https://aocdweb.com/BioTools/cocomaps1/">
                        <img src={cocomaps1logo} style={{position: 'relative', top: '-5px'}} alt="coco1" height={50}/>
                    </a>
                    at this
                    <a target="_blank" rel="noreferrer" href="https://aocdweb.com/BioTools/cocomaps1/">
                        link
                    </a>
                </p>
            </div>

            <div style={{padding: '30px'}}>
                <Form
                    form={pdbForm}
                    name="basic"
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Row>
                        <Col span={24}>
                            <Input.Group compact>
                                <Form.Item
                                    label="PDB code"
                                    extra="e.g. 2ZA4 - 2Z0B - pdb_00001b23"
                                    name="pdbCode"
                                >
                                    <Input placeholder="Insert PDB code"/>
                                </Form.Item>
                                <Form.Item
                                    label=" "
                                    name="pdbFile"
                                >
                                    <div style={{paddingTop: '3px', paddingLeft: '25px'}}>
                                        <Upload {...props} maxCount={1}>
                                            <Button icon={<UploadOutlined/>}>Click to Upload (PDB or mmCIF)</Button>
                                        </Upload>
                                    </div>
                                </Form.Item>
                                <Form.Item>
                                    <div style={{paddingTop: '32px', paddingLeft: '50px'}}>
                                        <Button type="primary" htmlType="submit" loading={loading}>
                                            Upload
                                        </Button>
                                    </div>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                    </Row>
                </Form>

                {pdbInfo !== null && (
                    <>
                        <Form
                            form={form}
                            name="basic"
                            layout="vertical"
                            initialValues={formInitialValues}
                            onFinish={valuesFormOnFinish}
                        >
                            <Row>
                                <Col>
                                    <Form.Item
                                        label="Chain/s molecule 1"
                                        extra="e.g. A or B"
                                        name="chains_set_1"
                                    >
                                        <Checkbox.Group options={availableChainsA}
                                                        onChange={onChainSelected('ranges_set_1')}/>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Form.List name="ranges_set_1">
                                    {(fields, {add, remove}) => (
                                        <>
                                            {fields.map(({key, name, ...restField}) => {
                                                const chain = form.getFieldValue(['ranges_set_1', name, 'chain']);
                                                const min = form.getFieldValue(['ranges_set_1', name, 'start']);
                                                const max = form.getFieldValue(['ranges_set_1', name, 'end']);
                                                return (
                                                    <>
                                                        <span>Range for chain {chain}</span>
                                                        <Input.Group compact>
                                                            <Form.Item
                                                                name={[name, "start"]}
                                                                extra={"Start " + chain}
                                                            >
                                                                <InputNumber min={min} max={max}/>
                                                            </Form.Item>
                                                            <div style={{paddingLeft: '10px'}}>
                                                                <Form.Item
                                                                    name={[name, "end"]}
                                                                    extra={"End " + chain}
                                                                >
                                                                    <InputNumber min={min} max={max}/>
                                                                </Form.Item>
                                                            </div>
                                                        </Input.Group>
                                                    </>
                                                )
                                            })}
                                        </>
                                    )}
                                </Form.List>
                            </Row>


                            <Row>
                                <Col>
                                    <Form.Item
                                        label="Chain/s molecule 2"
                                        extra="e.g. A or B"
                                        name="chains_set_2"
                                        rules={[{
                                            required: (selectedChain && selectedChain['ranges_set_1'].length),
                                            message: "Select at least 1 chain"
                                        }]}
                                    >
                                        <Checkbox.Group options={availableChainsB}
                                                        onChange={onChainSelected('ranges_set_2')}
                                                        disabled={(selectedChain['ranges_set_1'].length === 0)}/>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Form.List name="ranges_set_2">
                                    {(fields, {add, remove}) => (
                                        <>
                                            {fields.map(({key, name, ...restField}) => {
                                                const chain = form.getFieldValue(['ranges_set_2', name, 'chain']);
                                                const min = form.getFieldValue(['ranges_set_2', name, 'start']);
                                                const max = form.getFieldValue(['ranges_set_2', name, 'end']);
                                                return (
                                                    <>
                                                        <Input.Group compact>
                                                            <Form.Item
                                                                name={[name, "start"]}
                                                                extra={"Start " + chain}
                                                            >
                                                                <InputNumber min={min} max={max}/>
                                                            </Form.Item>
                                                            <div style={{paddingLeft: '10px'}}>
                                                                <Form.Item
                                                                    name={[name, "end"]}
                                                                    extra={"End " + chain}
                                                                >
                                                                    <InputNumber min={min} max={max}/>
                                                                </Form.Item>
                                                            </div>
                                                        </Input.Group>
                                                    </>
                                                )
                                            })}
                                        </>
                                    )}
                                </Form.List>
                            </Row>


                            <Divider orientation='left'>Advanced Options</Divider>

                            <Row>
                                <Col span={24}>
                                    <Collapse>
                                        <Panel header="Advanced Options (Optional)" key="1" forceRender>
                                            <Form.Item
                                                label="Project Name"
                                                name="PROJECT_NAME"
                                            >
                                                <Input placeholder="Project Name"/>
                                            </Form.Item>
                                            <Form.Item
                                                label="Email"
                                                name="EMAIL"
                                                extra="Optional"
                                            >
                                                <Input placeholder="Email"/>
                                            </Form.Item>
                                            <Form.Item
                                                label="Name Molecule 1"
                                                name="MOL_NAME_1"
                                                extra="Optional"
                                            >
                                                <Input placeholder="Name Molecule 1"/>

                                            </Form.Item>
                                            <Form.Item
                                                label="Name Molecule 2"
                                                name="MOL_NAME_2"
                                                extra="Optional"
                                            >
                                                <Input placeholder="Name Molecule 2"/>
                                            </Form.Item>
                                        </Panel>
                                        <Panel header="Cut-Off" key="2" forceRender>
                                            <Form.Item
                                                label="Cut-Off"
                                                name="CUT_OFF"
                                                extra="Threshold distance to select interacting residues in &#8491; (default value 5 &#8491;)"
                                            >
                                                <InputNumber min={4.0} max={8.0} step={0.1}/>
                                            </Form.Item>
                                        </Panel>

                                        <Panel header="Set interaction parameters" key="3" forceRender>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="H-bond dist"
                                                        name="HBOND_DIST"
                                                        extra="min: 2.5 - max: 5.5"
                                                    >
                                                        <InputNumber min={2.5} max={5.5} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="H-bond angle"
                                                        name="HBOND_ANGLE"
                                                        extra="min: 90 - max: 180"
                                                    >
                                                        <InputNumber min={90} max={180} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Salt-bridge dist"
                                                        name="SBRIDGE_DIST"
                                                        extra="min: 2.5 - max: 5.5"
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Water mediated dist"
                                                        name="WBRIDGE_DIST"
                                                        extra="min: 2.5 - max: 5.5"
                                                    >
                                                        <InputNumber min={2.5} max={5.5} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Disulfide bridge dist"
                                                        name="CH_ON_DIST"
                                                        extra="min: 2.0 - max: 3.7"
                                                    >
                                                        <InputNumber min={2.0} max={3.7} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Halogen theta 1"
                                                        name="HALOGEN_THETA1"
                                                        extra="min: 90 - max: 180"
                                                    >
                                                        <InputNumber min={90} max={180} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Halogen theta 2"
                                                        name="HALOGEN_THETA2"
                                                        extra="min: 90 - max: 180"
                                                    >
                                                        <InputNumber min={90} max={180} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Metal dist"
                                                        name="METAL_DIST"

                                                    >
                                                        <InputNumber disabled/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Pi-Pi dist"
                                                        name="PI_PI_DIST"
                                                        extra="min: 3.5 - max: 7.0"
                                                    >
                                                        <InputNumber min={3.5} max={7.0} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Pi-Pi theta"
                                                        name="PI_PI_THETA"
                                                        extra="min: 20 - max: 100"
                                                    >
                                                        <InputNumber min={20} max={100} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Pi-Pi gamma"
                                                        name="PI_PI_GAMMA"
                                                        extra="min: 20 - max: 100"
                                                    >
                                                        <InputNumber min={20} max={100} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Cation-Pi dist"
                                                        name="CATION_PI_DIST"
                                                        extra="min: 3.0 - max: 6.5"
                                                    >
                                                        <InputNumber min={3.0} max={6.5} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Anion-Pi dist"
                                                        name="ANION_PI_DIST"
                                                        extra="min: 3.0 - max: 6.5"
                                                    >
                                                        <InputNumber min={3.0} max={6.5} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="LonePair-Pi dist"
                                                        name="LONEPAIR_PI_DIST"
                                                        extra="min: 3.0 - max: 6.5"
                                                    >
                                                        <InputNumber min={3.0} max={6.5} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Amino-Pi dist"
                                                        name="AMINO_PI_DIST"
                                                        extra="min: 3.0 - max: 6.5"
                                                    >
                                                        <InputNumber min={3.0} max={6.5} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Ch-O/N dist"
                                                        name="CH_ON_DIST"
                                                        extra="min: 3.0 - max: 6.0"
                                                    >
                                                        <InputNumber min={3.0} max={6.0} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="CCh-O/N angle"
                                                        name="CH_ON_ANGLE"
                                                        extra="min: 90 - max: 180"
                                                    >
                                                        <InputNumber min={90} max={180} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="CH-Pi dist"
                                                        name="C_H_PI_DIST"
                                                        extra="min: 3.0 - max: 6.0"
                                                    >
                                                        <InputNumber min={3.0} max={6.0} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="CH-Pi theta 1"
                                                        name="C_H_PI_THETA1"
                                                        extra="min: 90 - max: 180"
                                                    >
                                                        <InputNumber min={90} max={180} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="CH-Pi theta 2"
                                                        name="C_H_PI_THETA2"
                                                        extra="min: 1 - max: 40"
                                                    >
                                                        <InputNumber min={1} max={40} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="N/O/SH-Pi dist"
                                                        name="NSOH_PI_DIST"
                                                        extra="min: 3.0 - max: 6.0"
                                                    >
                                                        <InputNumber min={3.0} max={6.0} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="N/O/SH-Pi theta 1"
                                                        name="NSOH_PI_THETA1"
                                                        extra="min: 90 - max: 180"
                                                    >
                                                        <InputNumber min={90} max={180} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="N/O/SH-Pi theta 2"
                                                        name="NSOH_PI_THETA2"
                                                        extra="min: 1 - max: 40"
                                                    >
                                                        <InputNumber min={1} max={40} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Apolar tolerance"
                                                        name="APOLAR_DIST"
                                                        extra="min: 0.1 - max: 1"
                                                    >
                                                        <InputNumber min={0.1} max={1} step={1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <Form.Item
                                                        label="Polar tolerance"
                                                        name="POLAR_DIST"
                                                        extra="min: 0.1 - max: 1"
                                                    >
                                                        <InputNumber min={0.1} max={1} step={0.1}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Panel>

                                    </Collapse>
                                </Col>
                            </Row>

                            <div style={{
                                position: "fixed",
                                width: '100%',
                                bottom: 0,
                                paddingBottom: '10px',
                                backgroundColor: 'white'
                            }}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        Submit
                                    </Button>
                                    <Button htmlType="button" style={{marginLeft: '10px'}} onClick={resetForm}>
                                        Reset
                                    </Button>
                                </Form.Item>
                            </div>

                        </Form>
                    </>)
                }
            </div>
            <Modal centered open={modalVisible} footer={null} maskClosable={false}
                   onCancel={() => window.location.reload()}>
                {dataFolder ? <Results dataFolder={dataFolder} chains={selectedChain} pdb={pdbCode} pn={pn} mol1={mol1}
                                       mol2={mol2}></Results>
                    : <>
                        <p>Job is running. Please wait for a few minutes.</p>
                        <p>Access to the result will be granted for three months from the date of creation.</p>
                        <LoadingOutlined style={{fontSize: 24, marginLeft: 10}} spin/>
                    </>}
            </Modal>
        </>
    );
}